import { Controller } from "@hotwired/stimulus"
import Chartkick from 'chartkick'
import { draw } from 'patternomaly'
import { clickToOpenURL, configureDataLabels, configureGroupStackDataLabels, getStackPattern } from '../utils/charts.js'

function getDatasetColor(name) {
  switch (name) { 
    case 'Emotional':
      return '#004651';
    case 'Physical':
      return '#108A93';
    case 'Social':
      return '#04C8C8';
    case 'Financial, academic and the future':
      return '#C8EFEF';
    default:
      return '#777777';
  }
}

function getDatasetOrder(name) {
  switch (name) {
    case 'Emotional':
      return 0;
    case 'Physical':
      return 1;
    case 'Social':
      return 2;
    case 'Financial, academic and the future':
      return 3;
    default:
      return 5;
  }
}

export default class extends Controller{
  static targets = ["link"]
  static values = { mode: String }

  connect() {
    const _this = this
    _this.stacks = []
    const _linkTarget = this.linkTarget
    setTimeout(function(){
      const chart = Chartkick.charts.needschart
      let chartConfig = chart.getChartObject().config
      chartConfig.options.layout = { padding: { left: 10, right: 10, top: 20, bottom: 20 } }
      chartConfig.options.interaction.mode = 'nearest'
      chart.getChartObject().data.datasets.forEach((dataset) => { 
        const color = getDatasetColor(dataset.label)
        if (_this.modeValue === 'grouped') {
          const pattern = getStackPattern(dataset.stack, _this.stacks)
          dataset.backgroundColor = draw(pattern, color);
          dataset.borderColor = draw(pattern, color)
        } else {
          dataset.backgroundColor = color;
          dataset.borderColor = color
        }
        dataset.order = getDatasetOrder(dataset.label)
        dataset.label = _this.modeValue === 'grouped' ? `${dataset.stack}: ${dataset.label}` : dataset.label
      })

      if (_this.modeValue === 'grouped') {
        configureGroupStackDataLabels(_this, chart)
      } else {
              chart.getChartObject().options.plugins.datalabels.color = (context) => {
        return context.dataset.backgroundColor;
      }
      chart.getChartObject().options.plugins.datalabels.anchor = 'end'
      chart.getChartObject().options.plugins.datalabels.align = 'end'
      chart.getChartObject().options.plugins.datalabels.offset = -4
      chart.getChartObject().options.plugins.datalabels.display = (context) => {
        return context.dataset.data[context.dataIndex] > 0;
      }

      }
      
      chart.getChartObject().options.plugins.legend.display = false
      chart.getChartObject().update()
      chartConfig.options.onClick = (event, native, active) => { 
        clickToOpenURL(chart, native, _linkTarget)
      }
    }, 1);
    
  } 
}